module.exports = __webpack_public_path__ + "img/antenna-02.d0080ae2.svg";